import React from 'react';
import { useDispatch } from 'react-redux';

import { logout } from 'state/actions/auth';
import { useHistory } from "react-router-dom";

const Logout = () => {
  const dispatch = useDispatch();
  // log the current session out
  dispatch(logout());

  const history = useHistory();
  // redirect back to root route
  history.push("/");

  return (
    <section className="section hero is-fullheight is-error-section">
    </section>
  );
};

export default Logout;
